import {React} from "react";

/**
 * Dummy page
 * @return {any}
 */
export default function Page() {
  return (<></>);
}
